<ng-container
  *ngIf="control"
  #container
>
  <label  class="form-label" *ngIf="label" [for]="name"
  >{{ label }}
    <ng-container *ngIf="tooltipText">
      <span><i [tooltip]="tooltipText" class="fa fa-info-circle"></i></span>
    </ng-container>
  </label>

  <div class="input-group has-validation">
    <span *ngIf="prefix" class="input-group-text">
      {{ prefix }}
    </span>

    <input
      currencyMask
      [autocomplete]="false"
      [id]="name"
      [ngModel]="inputValue"
      (ngModelChange)="changed($event)"
      [required]="control.hasValidator(requiredValidator)"
      type="text"
      [disabled]="control.disabled"
      [autofocus]="autofocus"
      [options]="currencyOptions"
      class="form-control"
      [class.form-control-sm]="small"
      [class.is-invalid]="(control.touched && !control.valid && !control.disabled)|| !!control.getError('serverError')"
      [class.is-valid]="(control.touched && control.valid && !control.disabled)"
      [placeholder]="placeholder"
    />

    <div class="invalid-feedback" *ngIf="!!control.getError('serverError')">{{ control.getError('serverError') }}</div>

    <ng-container *ngFor="let err of control.errors | keyvalue">
      <ng-container *ngIf="(control.touched && control.invalid)">
        <div *ngIf="errorMessages && errorMessages[err.key] " class="invalid-feedback">
          {{ errorMessages[err.key] }}
        </div>
        <div *ngIf="(!errorMessages || !errorMessages[err.key] ) && err.key !== 'serverError'" class="invalid-feedback">
          {{ 'forms.errors.' + err.key | translate }}
        </div>
      </ng-container>

    </ng-container>


  </div>
</ng-container>
